exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".refer-block{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;background-color:hsla(0,0%,91%,.87);border-radius:5px;text-align:left;padding:10px}.refer-block span{border-left:3px solid #00f;padding-left:10px}.preview-box{width:40px;height:40px;background-size:cover}", ""]);

// exports
